import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/useAuthStore'

interface RequireAuthProps {
  children: ReactNode
}

/** Location state carried to `/login` so the sign-in flow can return the user home. */
export interface AuthRedirectState {
  from?: string
}

export default function RequireAuth({ children }: RequireAuthProps): React.ReactElement {
  const location = useLocation()
  const session = useAuthStore((state) => state.session)
  const user = useAuthStore((state) => state.user)

  if (session?.needsBootstrap) return <Navigate to="/setup" replace />

  if (!user) {
    const from = `${location.pathname}${location.search}`
    return <Navigate to="/login" replace state={{ from } satisfies AuthRedirectState} />
  }

  return <>{children}</>
}

export { RequireAuth }
